module.exports = __webpack_public_path__ + "img/czleader11.a8f6c950.png";